import * as benchmark from './benchmark';
import * as classifiers from './classifiers';
import * as company from './company';
import * as companySearch from './companySearch';
import * as help from './help';
import * as search from './search';
import * as user from './user';

export const api = {
  benchmark,
  companySearch,
  company,
  search,
  classifiers,
  user,
  help,
};
